"use strict";

exports.__esModule = true;
exports.usePagination = usePagination;

var React = _interopRequireWildcard(require("react"));

var _useControlled2 = require("./useControlled");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var range = function range(start, end) {
  var length = end - start + 1;
  return Array.from({
    length: length
  }, function (_, i) {
    return start + i;
  });
};

function usePagination(params) {
  var _params$boundaries = params.boundaries,
      boundaries = _params$boundaries === void 0 ? 1 : _params$boundaries,
      _params$defaultPage = params.defaultPage,
      defaultPage = _params$defaultPage === void 0 ? 1 : _params$defaultPage,
      onChange = params.onChange,
      page = params.page,
      _params$rowsPerPage = params.rowsPerPage,
      rowsPerPage = _params$rowsPerPage === void 0 ? 10 : _params$rowsPerPage,
      _params$siblings = params.siblings,
      siblings = _params$siblings === void 0 ? 1 : _params$siblings,
      _params$totalRowCount = params.totalRowCount,
      totalRowCount = _params$totalRowCount === void 0 ? 1 : _params$totalRowCount;
  var pageCount = Math.ceil(totalRowCount / rowsPerPage);

  var _useControlled = (0, _useControlled2.useControlled)({
    defaultValue: defaultPage,
    onChange: onChange,
    value: page
  }),
      activePage = _useControlled[0],
      setActivePage = _useControlled[1];

  var next = function next() {
    return setActivePage(Number(activePage) + 1);
  };

  var previous = function previous() {
    return setActivePage(Number(activePage) - 1);
  };

  var setPage = function setPage(pageNumber) {
    return setActivePage(pageNumber);
  };

  var pages = React.useMemo(function () {
    var startRange = range(1, Math.min(boundaries, pageCount));
    var endRange = range(Math.max(pageCount - boundaries + 1, boundaries + 1), pageCount);
    var startIndex = Math.max(Math.min(Number(activePage) - siblings, pageCount - boundaries - siblings * 2 - 1), boundaries + 2);
    var endIndex = Math.min(Math.max(Number(activePage) + siblings, boundaries + siblings * 2 + 2), endRange.length > 0 ? endRange[0] - 2 : pageCount - 1);
    var siblingsEndRange = pageCount - boundaries > boundaries ? [pageCount - boundaries] : [];
    var siblingsStartRange = boundaries + 1 < pageCount - boundaries ? [boundaries + 1] : [];

    if (endIndex < pageCount - boundaries - 1) {
      siblingsEndRange = ['dots'];
    }

    if (startIndex > boundaries + 2) {
      siblingsStartRange = ['dots'];
    }

    return [].concat(startRange, siblingsStartRange, range(startIndex, endIndex), siblingsEndRange, endRange);
  }, [activePage, boundaries, pageCount, siblings]);
  return {
    next: next,
    page: activePage,
    pageCount: pageCount,
    pages: pages,
    previous: previous,
    setPage: setPage
  };
}